import React from "react";
import ReactTooltip from "react-tooltip";
import { MdContacts } from "react-icons/md";
import { FaBrain } from "react-icons/fa";
import {
  BsFillPatchCheckFill,
  BsInfoSquareFill,
  BsPersonWorkspace,
} from "react-icons/bs";
import { SiVisualstudiocode } from "react-icons/si";
import { useTheme } from "next-themes";

const links = [
  {
    name: "home",
    icons: <BsPersonWorkspace size={15} />,
  },
  {
    name: "about",
    icons: <BsInfoSquareFill size={15} />,
  },
  {
    name: "work",
    icons: <SiVisualstudiocode size={15} />,
  },
  {
    name: "skills",
    icons: <FaBrain size={15} />,
  },
  {
    name: "testimonial",
    icons: <BsFillPatchCheckFill size={15} />,
  },
  {
    name: "contact",
    icons: <MdContacts size={15} />,
  },
];

const NavigationDots = ({ active }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="app__navigation dark:bg-darktheme dark:transition-all relative z-10">
      {links.map((item, index) => (
        <div className="flex m-1 rounded-full border border-[#e4e4e4] bg-white dark:bg-darkthemealt dark:border-[#2d3138] transition-all">
          <a
            href={`#${item.name}`}
            key={item.name + index}
            data-tip={item.name}
            className={`app__navigation-dot text-black dark:text-slate-50 hover:text-[#313bac] dark:hover:text-[#78ffd6]`}
            style={
              (active === item.name) & (theme === "dark")
                ? { color: "#78ffd6" }
                : (active === item.name) & (theme === "light")
                ? { color: "#313bac" }
                : {}
            }
          >
            {item.icons}
          </a>
          <ReactTooltip effect="solid" type="dark" place="right"></ReactTooltip>
        </div>
      ))}
    </div>
  );
};

export default NavigationDots;
